import React from "react";
import {useAppSelector} from "@nextlot/core/webcast/hooks";


export default function NetworkDisconnectedAlertPanelOverlayCmp() {

    const wbsNetworkConnectionState = useAppSelector(reduxState => reduxState.activeWebcast.wbsNetworkStatus.connectionState);

    const [reloadPageInProgress, setReloadPageInProgress] = React.useState<boolean>(false);

    const handleClick_ReloadPageButton = (evt)  => {
        setReloadPageInProgress(true);
        window.location.reload();
    };


    if (wbsNetworkConnectionState > 0) {
        // don't render anything if connected or connect is in progress
        return null;
    }

    return (
        <div className="network-disconnected-alert-container">
            <div className="alert-panel">
                <h3>Network error</h3>
                <p>Oops...You were unable to connect to the Webcast!</p>
                <p>This may be because:</p>
                <p>- You left your browser on your mobile device and will be required to refresh when returning to the auction. </p>
                <p>- You are no longer connected to the internet.</p>
                <p>- The auction company has not started the auction. Please check back in a few minutes.</p>
                <p>- A firewall is blocking outgoing port 443 (HTTPS). Please get in touch with your IT contact to
                    have them open port 443 (HTTPS) on your router.</p>
                <p/>

                <p>You can try to reload the page and this will attempt to reconnect.</p>

                <div className='d-flex flex-row align-items-center'>
                    <button type="button" className='btn btn-lg btn-dark me-3' onClick={handleClick_ReloadPageButton} disabled={reloadPageInProgress}>Reload page</button>
                    {reloadPageInProgress && <i className="fa-regular fa-sync fa-spin" />}
                </div>
            </div>
        </div>
    )
}

